import { put, takeEvery } from "redux-saga/effects";
import { actions } from "redux-store/slices/index";

export function* postEventSaga() {
  yield takeEvery(
    actions.postMerchantsEventsByMerchantId.success.type,
    function* () {
      yield put(actions.setIsCreateEventDialogOpen(false));
    },
  );
}

export function* editEventSaga() {
  yield takeEvery(
    actions.patchMerchantsEventsByMerchantIdAndEventId.success.type,
    function* () {
      yield put(
        actions.setEditEventDialogState({
          isOpen: false,
          editMode: false,
          editImage: false,
          selectedEvent: null,
        }),
      );
    },
  );
}
